<template>
  <div>
    <b-form @submit.prevent="submit()" class="form-horizontal">
      <b-form-group :label="'Goal ' + n"
                    label-class="control-label" :class="{ 'invalid-group': $v.goal.$error }">
        <b-form-textarea 
                  v-model="goal"
                  placeholder="Enter your goals"
                  :rows="3"
                  :max-rows="6"
                  :class="{ 'is-invalid': $v.goal.$error }"
                  @input="handleInput">
        </b-form-textarea>
        <span class="span-feedback invalid-feedback" v-if="$v.goal.$error">You must enter a goal.</span>
      </b-form-group>      
    </b-form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      goal: ""
    };
  },

  props: {
    value: {
      required: false
    },
    n: {
      required: false
    },
    submitted: {
      required: false
    }
  },

  validations: {
    goal: { required }
  },

  methods: {
    handleInput: function() {
      this.returnItem();
    },
    validate: function() {
      this.$v.$touch();
      this.returnItem();
    },
    returnItem: function() {
      this.$emit("input", this.goal);
    },
    isInvalid: function() {
      return this.$v.$invalid;
    },
    submit: function() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit("submitted");
      }
    }
  },

  watch: {
    value: {
      handler: function() {
        this.goal = this.value;
      },
      deep: true
    }
  },

  created() {
    if (this.value) {
      this.goal = this.value;
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
